<template>
    <span>
        <btn :disabled="dirty" icon="fa fa-sticky-note" :click="openAttachBillingNoteModal">Attach billing note</btn>
        
        <div class="modal fade" :id="'billing-'+billing_period_id+'-note-modal'" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title">Attach billing note</h4>
                    </div>
                    <div v-loading="loading" class="modal-body">
                        <textarea class="form-control" rows="2" v-model="text"></textarea>
                        <div class="form-check">
                          <input type="checkbox"
                                 class="form-check-input"
                                 id="is-channel-message"
                                 v-model="isChannelMessage"
                          />
                          <label class="form-check-label" for="is-channel-message">@channel</label>
                        </div>
                    </div>
                    <div class="modal-footer" style="text-align: right">
                        <btn type="button" :click="addNote">Add Note</btn>
                        <button type="button" class="btn" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </span>
</template>

<script>
export default {
    props: [
        'billing_period_id'
    ],
    data() {
        return {
            loading: true,
            dirty: false,
            text: '',
            isChannelMessage: false
        };
    },
    methods: {
        openAttachBillingNoteModal() {
            this.refresh();
            $('#billing-'+this.billing_period_id+'-note-modal').modal();
        },
        refresh() {
            this.text = '';
            this.loading = true;
            return axios.get(url(`admin/budget-emails/${this.billing_period_id}/note`))
                .then(response => {
                    this.loading = false;
                    this.text = response.data.text;
                });
        },
        addNote() {
            return axios.post(url(`admin/budget-note/${this.billing_period_id}/add`), {
                text: this.text,
                isChannelMessage: this.isChannelMessage
            }).then(response => {
                this.$emit('refresh-notes');
                $('#billing-'+this.billing_period_id+'-note-modal').modal('hide');
            });
        }
    },
}
</script>
